import React from 'react'

interface SkeletonProps {
  width?: string | number
  height?: string | number
  borderRadius?: string
  style?: React.CSSProperties
}

export function Skeleton({ width, height = 20, borderRadius, style }: SkeletonProps) {
  return (
    <div
      className="skeleton"
      style={{
        width: width ?? '100%',
        height,
        borderRadius: borderRadius ?? 'var(--radius-md)',
        ...style,
      }}
    />
  )
}

export function SkeletonText({ lines = 3, style }: { lines?: number; style?: React.CSSProperties }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8, ...style }}>
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton
          key={i}
          height={14}
          width={i === lines - 1 ? '60%' : '100%'}
        />
      ))}
    </div>
  )
}
